import React from 'react';
import { Link } from 'react-router-dom';
import InfoPage from '../components/InfoPage';

const steps = [
  ['Shop', 'Make an eligible purchase.'],
  ['Send your receipt', 'Forward your digital receipt to your KACHNG address.'],
  ['KACHNG processes it', 'Your receipt becomes organized spending intelligence while KACHNG checks whether it qualifies for rewards.'],
  ['Earn', 'Eligible receipts and activity earn KACHNG points. See your balance and history in the app.'],
  ['Redeem', 'Redeem eligible rewards according to the KACHNG Rewards program and the options available to your account.'],
];
export default function Rewards() {
  return <InfoPage title="Rewards" intro="Turn receipts into rewards.">

    <section className="legal-section" aria-labelledby="how-rewards-work">
      <h2 id="how-rewards-work">How KACHNG Rewards work</h2>
      <p><strong>KACHNG Rewards and sweepstakes are for participants aged 18 or older.</strong> You must be 18 when earning rewards or entering a giveaway. Rewards earned while under 18 are ineligible and forfeited if identified; related pending redemptions are canceled. Underage sweepstakes entries are void, and an underage entrant selected as a potential winner forfeits the prize. See the <Link to="/terms#rewards">age eligibility and Rewards Terms</Link>.</p>

      <ol className="info-steps">{steps.map(([title, text], index) => <li key={title}>
        <span className="info-step-number" aria-hidden="true">0{index + 1}</span>
        <div><h3>{title}</h3>
      <p>{text}</p></div>
      </li>)}</ol>

    </section>

    <section className="legal-section">
      <h2>Know what you earn</h2>

      <table><caption>Current KACHNG Rewards earning rates</caption><thead><tr><th scope="col">Qualifying activity</th><th scope="col">Points</th></tr></thead>
        <tbody><tr><th scope="row">Receipt</th><td>50</td></tr><tr><th scope="row">New merchant bonus</th><td>100</td></tr><tr><th scope="row">Survey</th><td>500</td></tr><tr><th scope="row">Referral</th><td>1,000</td></tr></tbody>
      </table>
      <p>Survey and referral opportunities depend on availability and their eligibility requirements. The new merchant bonus applies to a merchant you haven’t used before.</p>
      <div className="info-callout info-redemption"><h3>500 points = $1.00</h3>
      <p className="info-redemption-minimum">$10 minimum redemption</p>
      <p>Points do not expire under the current program.</p>
      </div>
      <p>Redeem cash through PayPal or Venmo. KACHNG processes cash-out requests within 12 hours. Payment availability may also depend on the payment provider. For help redeeming or understanding your balance, <Link to="/contact">contact us</Link>.</p>

    </section>

    <section className="legal-section"><h2>A few simple rules</h2>

      <div className="info-grid">
        <div className="info-card"><h3>What counts?</h3>
      <p>Eligible accounts can earn points for valid, verifiable receipts and qualifying activity under the current Rewards rules. Not every submission qualifies.</p>
      </div>
        <div className="info-card"><h3>One purchase. One reward.</h3>
      <p>A receipt can qualify only once. Sending it again does not create additional rewards.</p>
      </div>
        <div className="info-card"><h3>Keep it real.</h3>
      <p>Fraudulent, altered, duplicated, or manipulated receipts are not eligible. We may correct balances or reverse points credited in error or through abuse.</p>
      </div>
        <div className="info-card"><h3>Your data isn’t the product.</h3>
      <p>KACHNG does not sell your purchase history or spending information to fund Rewards. <Link to="/privacy">Read our Privacy Policy</Link>.</p>
      </div>
      </div>

    </section>

    <section className="legal-section"><h2>Rewards Terms</h2>
      <p>See the <Link to="/terms#rewards">KACHNG Rewards Terms</Link> for eligibility, balance corrections, redemption, account closure, and program changes.</p>
      <p>KACHNG runs a monthly giveaway for eligible participants aged 18 or older. Each giveaway has its own dates, prize, and entry requirements. See the <Link to="/sweepstakes-rules">Official Sweepstakes Rules</Link> and the announcements for each giveaway. The April 2026 giveaway has ended.</p>

    </section>
  </InfoPage>;
}
